export const MENTION_DENOTATION_CHARS = ['##'];
